export const ANALYTICS_CONFIG = {
  MEASUREMENT_ID: import.meta.env.VITE_GA4_MEASUREMENT_ID || 'G-764PEEDJCD',
  DEBUG_MODE: import.meta.env.MODE === 'development',
  SITE_SPEED_SAMPLE_RATE: 100,
  ENABLED: false,
} as const;

export const ANALYTICS_EVENTS = {
  PAGE_VIEW: 'page_view',
  INVOICE_CREATED: 'invoice_created',
  ITEM_ADDED: 'item_added',
  CUSTOMER_ADDED: 'customer_added',
  PAYMENT_RECEIVED: 'payment_received',
} as const; 